export default "__VITE_ASSET__Bbyp4dw2__"